import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "../ui/api";

export const getOrganisationalStructure = createAsyncThunk(
  "courses/fetchOrganizationalStructure",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get("/courses/organisational-structure/");
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.detail || error.message);
    }
  }
);

const organisationalSlice = createSlice({
  name: "organisationalStructure",  
  initialState: {
    items: [],
    organisationalStructure: null, 
    loading: false,
    error: null,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getOrganisationalStructure.pending, (state) => {
        state.loading = true;
      })
      .addCase(getOrganisationalStructure.fulfilled, (state, action) => {
        state.loading = false;
        state.organisationalStructure = action.payload;
      })
      .addCase(getOrganisationalStructure.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default organisationalSlice.reducer;
